import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export function useSubscription() {
  const {
    isPlusActive,
    isEnhancedActive,
    subscriptionStatus,
    planName,
    isHydrating,
    hasFeature,
  } = useContext(AuthContext);

  return {
    isPlusActive,
    isEnhancedActive,
    status: subscriptionStatus,
    plan: planName,
    isLoading: isHydrating,
    hasFeature,
  };
}
